"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UnsupportedTypeError extends Error {
    constructor(type, message) {
        super(`Unsupported type: ${type}, message: ${message}`);
        this.type = type;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }
    }
}
exports.default = UnsupportedTypeError;
//# sourceMappingURL=UnsupportedTypeError.js.map